export default "__VITE_ASSET__D$JHBxG9__"